import { create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import {
  CreateUserApplicationRequestObjectType,
  CreateUserApplicationResponseType,
  ExecuteSectionActionRequestObjectType,
  GetApplicationDiscountDetailsRequestObjectType,
  GetApplicationDiscountDetailsResponseType,
  GetApplicationSectionDetailsResponseType,
  GetOrCreateApplicationSectionVisitRequestObjectType,
  GetOrCreateApplicationSectionVisitResponseType,
  GetTemplateResponseRequestObjectType,
  GetTemplateResponseResponseType,
  GetUserApplicationDetailsRequestObjectType,
  GetUserApplicationDetailsResponseType,
  GetUserAssessmentReportRequestObjectType,
  GetUserAssessmentReportResponseType,
  GetUserIdentityAccessTokenRequestObjectType,
  GetUserIdentityAccessTokenResponseType,
  LinkUserApplicationRequestObjectType,
  RecordDiscountInteractionRequestObjectType,
  RecordDiscountInteractionResponseType,
  UpdateMultipleTemplateResponseRequestObjectType,
  UpdateMultipleTemplateResponseResponseType,
  UpdateTemplateResponseRequestObjectType,
  UpdateTemplateResponseResponseType,
  UpdateUserApplicationRequestObjectType,
  UpdateUserApplicationResponseType
} from './types';

import { NwApplicationServiceTypes } from '.';

class NwApplicationService implements NwApplicationServiceTypes {
  api: Record<string, any>;
  networkCallWithAPISauce: any;
  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['NW_APPLICATION_BASE_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  getApplicationSectionsDetails = (
    applicationNameEnum: string
  ): Promise<GetApplicationSectionDetailsResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/${applicationNameEnum}/sections/details/v1/`,
      {},
      apiMethods.get
    );
  };

  getUserApplicationDetails = (
    applicationNameEnum: string,
    requestObject: GetUserApplicationDetailsRequestObjectType,
    customNetworkCalWithDiffAccessToken?
  ): Promise<GetUserApplicationDetailsResponseType> => {
    if (customNetworkCalWithDiffAccessToken) {
      return customNetworkCalWithDiffAccessToken(
        this.api,
        `user/application/${applicationNameEnum}/details/v1/`,
        requestObject,
        apiMethods.post
      );
    } else
      return this.networkCallWithAPISauce(
        this.api,
        `user/application/${applicationNameEnum}/details/v1/`,
        requestObject,
        apiMethods.post
      );
  };

  createUserApplication = (
    requestObject: CreateUserApplicationRequestObjectType
  ): Promise<CreateUserApplicationResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `user/application/create/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  updateUserApplication = (
    requestObject: UpdateUserApplicationRequestObjectType
  ): Promise<UpdateUserApplicationResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `user/application/update/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  updateMultipleTemplateResponse = (
    requestObject: UpdateMultipleTemplateResponseRequestObjectType
  ): Promise<UpdateMultipleTemplateResponseResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/template_responses/update/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  linkUserApplication = (
    requestObject: LinkUserApplicationRequestObjectType
  ): Promise<void> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/link_user/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  getUserIdentityAccessToken = (
    requestObject: GetUserIdentityAccessTokenRequestObjectType
  ): Promise<GetUserIdentityAccessTokenResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/user/access_token/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  updateTemplateResponse = (
    requestObject: UpdateTemplateResponseRequestObjectType
  ): Promise<UpdateTemplateResponseResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/template_response/update/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  getTemplateResponse = (
    requestObject: GetTemplateResponseRequestObjectType
  ): Promise<GetTemplateResponseResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/template_response/get/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  getOrCreateApplicationSectionVisit = (
    requestObject: GetOrCreateApplicationSectionVisitRequestObjectType
  ): Promise<GetOrCreateApplicationSectionVisitResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/section/visit/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  executeSectionAction = (
    requestObject: ExecuteSectionActionRequestObjectType
  ): Promise<void> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/section/action/execute/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  getUserAssessmentReport = (
    requestObject: GetUserAssessmentReportRequestObjectType
  ): Promise<GetUserAssessmentReportResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `user/assessment_report/get/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  getApplicationDiscountDetails = (
    requestObject: GetApplicationDiscountDetailsRequestObjectType
  ): Promise<GetApplicationDiscountDetailsResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/coupon_details/v1/`,
      requestObject,
      apiMethods.post
    );
  };

  recordDiscountInteraction = (
    requestObject: RecordDiscountInteractionRequestObjectType
  ): Promise<RecordDiscountInteractionResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `application/coupon_details/interaction/v1/`,
      requestObject,
      apiMethods.post
    );
  };
}

export { NwApplicationService };
